import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bookmark, ArrowRight } from "lucide-react";
import { api } from "../lib/api";
import Navbar from "../components/Navbar";
import MovieCard from "../components/MovieCard";
import Footer from "../components/Footer";

export default function MyList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();
  useEffect(() => {
    api.get("/watchlist")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <Navbar />
      <main className="pt-28 px-6 lg:px-12 max-w-[1600px] mx-auto pb-20">
        <h1 className="text-4xl md:text-5xl font-bold mb-8">My List</h1>
        {loading ? (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4">
            {Array.from({ length: 12 }).map((_, i) => (
              <div key={i} className="skeleton aspect-[2/3] rounded-md" />
            ))}
          </div>
        ) : items.length === 0 ? (
          <div
            data-testid="mylist-empty"
            className="relative overflow-hidden rounded-xl border border-white/10 bg-gradient-to-br from-[#161616] to-[#0a0a0a] px-8 py-16 text-center"
          >
            <div className="absolute inset-0 opacity-[0.07] pointer-events-none"
                 style={{
                   backgroundImage: "radial-gradient(circle at 20% 30%, #E50914 0%, transparent 40%), radial-gradient(circle at 80% 70%, #f6c34a 0%, transparent 35%)",
                 }} />
            <div className="relative max-w-md mx-auto">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#E50914]/15 border border-[#E50914]/30 mb-5">
                <Bookmark className="w-7 h-7 text-[#E50914]" />
              </div>
              <h2 className="text-2xl md:text-3xl font-black mb-2">Your list is empty</h2>
              <p className="text-gray-400 mb-6 leading-relaxed">
                Browse the catalog and tap the bookmark on any film or series to save it here. Your list syncs across every device.
              </p>
              <button
                data-testid="mylist-empty-cta"
                onClick={() => nav("/browse")}
                className="btn-red px-6 py-2.5 rounded font-semibold inline-flex items-center gap-2"
              >
                Discover titles <ArrowRight className="w-4 h-4" />
              </button>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 animate-fade-up">
            {items.map((v) => <MovieCard key={v.id} video={v} />)}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
